// extracted by mini-css-extract-plugin
module.exports = {"genres":"MainPage-styles_genres__3LAkr","genresTitle":"MainPage-styles_genresTitle__23a0a"};